'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Button = require('../../Button/src/Button.js');
var Icon = require('../../Icon/src/Icon.js');
var PaginationButton_module = require('../styles/PaginationButton.module.less.js');

const PaginationButton = (props) => {
    const { pageNumber, currentPage, onPageChanged } = props;
    const cx = reactUtils.useStyles(PaginationButton_module.default);
    if (typeof pageNumber === 'string') {
        return (React.createElement(Button.Button, { variant: "text", className: cx('dots') },
            React.createElement(Icon.Icon, { icon: React.createElement(reactIcons.ThreeDots, null) })));
    }
    const page = pageNumber - 1;
    return (React.createElement(Button.Button, { "data-qa": "PaginationButton", onClick: () => onPageChanged(page), variant: page === currentPage ? 'outlined' : 'text', color: page === currentPage ? 'blue' : 'dark', 
        // eslint-disable-next-line @typescript-eslint/naming-convention
        className: cx({ 'selected-page': page === currentPage }) }, pageNumber));
};

exports.PaginationButton = PaginationButton;
//# sourceMappingURL=PaginationButton.js.map
